import React from 'react';
import { Typography, Button, Container, Box, Paper } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const HomePage: React.FC = () => {
  const { volunteer } = useAuth();

  return (
    <Container maxWidth="lg">
      <Box
        sx={{
          mt: { xs: 4, md: 8 },
          mb: 4,
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography 
          variant="h1" 
          component="h1" 
          gutterBottom
          sx={{
            fontWeight: 700,
            color: 'primary.main',
            fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
            mb: 3,
          }}
        >
          Strudengauer Messe
        </Typography>
        <Typography 
          variant="h5" 
          align="center" 
          color="text.secondary" 
          sx={{ 
            maxWidth: '800px',
            mb: 6,
            px: 2,
          }}
        >
          Helfer-Portal für die Strudengauer Messe
        </Typography>

        {!volunteer ? (
          <Box sx={{ 
            display: 'flex', 
            flexWrap: 'wrap', 
            gap: 4,
            width: '100%',
            justifyContent: 'center',
          }}>
            <Box sx={{ 
              flexBasis: { xs: '100%', md: 'calc(50% - 16px)' }, 
              flexGrow: 1,
              maxWidth: '600px',
            }}>
              <Paper
                sx={{
                  p: 4,
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  backgroundColor: 'background.paper',
                  borderRadius: '0.5rem',
                }}
                elevation={0}
              >
                <Typography variant="h4" gutterBottom color="primary.main">
                  Helfen Sie mit!
                </Typography>
                <Typography paragraph>
                  Vielen Dank für Ihr Interesse an der Strudengauer Messe. 
                  Wir brauchen Ihre Hilfe, um diese Veranstaltung zu einem Erfolg zu machen!
                </Typography>
                <Typography paragraph>
                  Als Helfer haben Sie die Möglichkeit, einen wichtigen Beitrag für Ihre Gemeinschaft zu leisten, 
                  neue Menschen kennenzulernen, und wenn Sie eine bestimmte Zeit helfen.
                </Typography>
                <Box sx={{ mt: 'auto', pt: 3 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    component={RouterLink}
                    to="/jobs"
                    size="large"
                    fullWidth
                    sx={{
                      py: 1.5,
                      fontWeight: 600,
                    }}
                  >
                    Verfügbare Dienste ansehen
                  </Button>
                </Box>
              </Paper>
            </Box>
            <Box sx={{ 
              flexBasis: { xs: '100%', md: 'calc(50% - 16px)' }, 
              flexGrow: 1,
              maxWidth: '600px',
            }}>
              <Paper
                sx={{
                  p: 4,
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  backgroundColor: 'background.paper',
                  borderRadius: '0.5rem',
                }}
                elevation={0}
              >
                <Typography variant="h4" gutterBottom color="primary.main">
                  Bereits registriert?
                </Typography>
                <Typography paragraph>
                  Wenn Sie bereits ein Konto haben, melden Sie sich an, um Ihre Registrierungen anzusehen oder sich für weitere Dienste anzumelden.
                </Typography>
                <Box sx={{ mt: 'auto', pt: 3 }}>
                  <Button
                    variant="contained"
                    color="secondary"
                    component={RouterLink}
                    to="/login"
                    size="large"
                    fullWidth
                    sx={{
                      py: 1.5,
                      fontWeight: 600,
                    }}
                  >
                    Anmelden
                  </Button>
                </Box>
                <Box sx={{ mt: 2, pt: 2 }}>
                  <Button
                    variant="outlined"
                    color="primary"
                    component={RouterLink}
                    to="/register"
                    size="large"
                    fullWidth
                    sx={{
                      py: 1.5,
                      fontWeight: 600,
                    }}
                  >
                    Als Helfer registrieren
                  </Button>
                </Box>
              </Paper>
            </Box>
          </Box>
        ) : (
          <Box sx={{ 
            mt: 4, 
            textAlign: 'center',
            maxWidth: '600px',
            width: '100%',
          }}>
            <Typography 
              variant="h4" 
              gutterBottom 
              color="primary.main"
              sx={{ fontWeight: 600 }}
            >
              Willkommen zurück, {volunteer.name}!
            </Typography>
            <Typography variant="body1" paragraph color="text.secondary">
              Vielen Dank für Ihre Mithilfe.
            </Typography>
            <Box sx={{ 
              display: 'flex', 
              gap: 2, 
              justifyContent: 'center',
              flexWrap: 'wrap',
              mt: 4,
            }}>
              <Button
                variant="contained"
                color="primary"
                component={RouterLink}
                to="/volunteer/dashboard"
                size="large"
                sx={{ minWidth: '200px', py: 1.5 }}
              >
                Mein Dashboard
              </Button>
              <Button
                variant="outlined"
                color="primary"
                component={RouterLink}
                to="/jobs"
                size="large"
                sx={{ minWidth: '200px', py: 1.5 }}
              >
                Dienste durchsuchen
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default HomePage;
